import React from 'react';
import SvgIcon from '../SvgIcon';

/**
 * @ignore - internal component.
 */
function Folder(props) {
  return (
    <SvgIcon {...props}>
      <path d="M9.17 6l2 2H20v10H4V6h5.17M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z"/>
    </SvgIcon>
  );
}

export default React.memo(Folder);



// WEBPACK FOOTER //
// ./src/icons/internals/Folder.jsx